export const environment = {
    production: true,
    apiUrl: "https://test.kofd.kz",
    botName: 'test_k_o_f_d_bot'
  };
